
import React from 'react';

interface DressIconProps extends React.SVGProps<SVGSVGElement> {}

const DressIcon: React.FC<DressIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 21H4.883a1.875 1.875 0 01-1.84-2.183l.501-6.013a1.875 1.875 0 011.84-1.617h1.116M6 21v-7.5M6 21h12v-7.5M18 21h1.117a1.875 1.875 0 001.84-1.617l.501-6.013A1.875 1.875 0 0019.117 12h-1.116M9 6.75l.912-.608a3 3 0 013.176 0L15 6.75M9 6.75v1.5M15 6.75v1.5M6.375 9h11.25" />
  </svg>
);

export default DressIcon;
